// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"88":"4b198cdd","584":"02683914"}[chunkId] + ".chunk.css";
};